// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.wlecomsign {
  color: white;
  font-size: 1.5rem;
  position: relative;
  text-align: right;
  top: 35%;
  right: 10%;
}

.report-table {
  font-size: 15px;
}

.report-table th {
  background-color: #f8f9fa;
  font-weight: 600;
  vertical-align: middle;
}

.report-table th small {
  font-size: 12px;
  color: #888;
}

.report-table td {
  vertical-align: middle;
}

.report-table tbody tr:hover {
  background-color: #f1f7ff;
  transition: background-color 0.15s ease-in-out;
}

/* 強化第一欄 */
.report-table td:first-child {
  background-color: #fafafa;
}

/* 今年至今：淡綠色 */
.table-success {
  background-color: #eaf8f0 !important;
}

/* 去年：淡黃色 */
.table-warning {
  background-color: #fff6e5 !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/admreport/styles/adm.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACI,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,QAAA;EACA,UAAA;AAEJ;;AACA;EACE,eAAA;AAEF;;AACA;EACE,yBAAA;EACA,gBAAA;EACA,sBAAA;AAEF;;AACA;EACE,eAAA;EACA,WAAA;AAEF;;AACA;EACE,sBAAA;AAEF;;AACA;EACE,yBAAA;EACA,8CAAA;AAEF;;AACA,UAAA;AACA;EACE,yBAAA;AAEF;;AACA,aAAA;AACA;EACE,oCAAA;AAEF;;AACA,WAAA;AACA;EACE,oCAAA;AAEF","sourcesContent":[".wlecomsign {\n    color: #ffff;\n    font-size: 1.5rem;\n    position: relative;\n    text-align: right;\n    top: 35%;\n    right: 10%;\n}\n\n.report-table {\n  font-size: 15px;\n}\n\n.report-table th {\n  background-color: #f8f9fa;\n  font-weight: 600;\n  vertical-align: middle;\n}\n\n.report-table th small {\n  font-size: 12px;\n  color: #888;\n}\n\n.report-table td {\n  vertical-align: middle;\n}\n\n.report-table tbody tr:hover {\n  background-color: #f1f7ff;\n  transition: background-color 0.15s ease-in-out;\n}\n\n/* 強化第一欄 */\n.report-table td:first-child {\n  background-color: #fafafa;\n}\n\n/* 今年至今：淡綠色 */\n.table-success {\n  background-color: #eaf8f0 !important;\n}\n\n/* 去年：淡黃色 */\n.table-warning {\n  background-color: #fff6e5 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
